import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let session = JSON.parse(localStorage.getItem("session"))

export default new Vuex.Store({
 state: {
   isLogged: Boolean(session && session.access_token),
   report: {},
   name: '',
   pipeline_id: '',
   build_url: '',
   status: '',
   pull_request_url:'',
   config_yaml: {
     config: {
       project_repos: [],
       credentials: []
     },
     sqa_criteria: {},
     environment: {}
   },
   docker_compose: {
     version: "3.7",
     id_cred_service: "",
     services: {}
   },
   criteria: undefined
 },
 getters: {},
 mutations: {},
 actions: {}
});
